import { AfterViewInit, Directive, ElementRef, EventEmitter, Inject, Input, Output } from '@angular/core';
import * as $ from 'jquery';
import * as daterangepicker from 'daterangepicker'; // Import DateRangePicker
import * as moment from 'moment'; // Import moment

@Directive({
  selector: '[appDaterangepicker]'
})
export class DaterangepickerDirective implements AfterViewInit {

  @Input('format') format: any;
  @Input('start') start: any;
  @Input('end') end: any;
  @Output() change = new EventEmitter<any>();

  constructor(private el: ElementRef) {

  }
  ngAfterViewInit(): void {
    console.log(daterangepicker)
    let options = {
      timePicker: true,
      locale: {
        format: this.format
      }
    } as any;
    
    const rex = /([+-]\d{2}:\d{2})$/;
    if (this.start && this.end) {
      options.startDate = moment(this.start.replace(rex, ''))
      options.endDate = moment(this.end.replace(rex, ''))
    }
    $(this.el.nativeElement).daterangepicker(options, (start, end, label) => {
      // Emit the start and end dates in the specified timezone

      const startDate = start.format('YYYY-MM-DD HH:mm:ss');
      const endDate = end.format('YYYY-MM-DD HH:mm:ss');
      this.change.emit({ start: startDate, end: endDate });
    });
  }

}
